module.exports = __webpack_public_path__ + "static/media/14_potolok_0_0.ce978f66.png";